module.exports = {
    app_url: process.env.REACT_APP_APP_URL,
    api_url: process.env.REACT_APP_API_URL,
    content_url: process.env.REACT_APP_CONTENT_URL,
};
